import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "./initialState";
import api from "../api";

export const GetAllSurveyUser = createAsyncThunk(
  "survey/GetAllSurveyUser",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(`${api}master/survey`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllSurvey = createAsyncThunk(
  "survey/GetAllSurvey",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(`${api}master/survey/all?${data.url}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSingleSurvey = createAsyncThunk(
  "survey/GetSingleSurvey",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/survey/get_by_id/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const surveySlice = createSlice({
  name: "survey",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get all survey dropdown
    builder.addCase(GetAllSurveyUser.pending, loadingHandler);
    builder.addCase(GetAllSurveyUser.fulfilled, fulfilledHandler);
    builder.addCase(GetAllSurveyUser.rejected, rejectedHandler);
    // get all survey
    builder.addCase(GetAllSurvey.pending, loadingHandler);
    builder.addCase(GetAllSurvey.fulfilled, fulfilledHandler);
    builder.addCase(GetAllSurvey.rejected, rejectedHandler);
    // get Single survey
    builder.addCase(GetSingleSurvey.pending, loadingHandler);
    builder.addCase(GetSingleSurvey.fulfilled, fulfilledHandler);
    builder.addCase(GetSingleSurvey.rejected, rejectedHandler);
  },
});

export const { reset } = surveySlice.actions;
export default surveySlice.reducer;
